<script setup lang="js">
import AdminLayout from '@/layouts/AdminLayout.vue'
import ModuleSettings from '@/views/Admin/SuperAdmin/ModuleSettings.vue'
import AppServiceErrors from '@/views/Admin/SuperAdmin/AppServiceErrors.vue'
import EmailLogs from '@/views/Admin/SuperAdmin/EmailLogs.vue'
import { computed, ref } from 'vue'
import Maintenance from '@/views/Admin/SuperAdmin/Maintenance.vue'
import ScheduledReportSettings from '@/views/Admin/SuperAdmin/ScheduledReportSettings.vue'
import PortalSettingsPage from '@/views/Admin/SuperAdmin/PortalSettingsPage.vue'
import { systemEchoes } from '@/composables/echo/useSystemEchoes.js'

const tabs = [
	{ name: 'Portal Settings' },
	{ name: 'App Service Errors' },
	{ name: 'Maintenance' },
	{ name: 'Module Settings' },
	{ name: 'Email Log' },
	{ name: 'Scheduled Report Settings' },
]
const currentTabIndex = ref(0)

//Populated from the '.presence.updated' event on the system channel, which every logged-in user is
//already subscribed to via systemEchoes.systemConnect() (see App.vue) -- no separate connect/listen needed here.
const connUsers = computed(() => systemEchoes.connectedUsers.value)

function tabSelected(tabIndex) {
	currentTabIndex.value = tabIndex
}
</script>

<template>
	<AdminLayout>
		<nav class="flex border-b border-neutral-subtle py-2">
			<ul role="list" class="flex flex-col md:flex-row min-w-full flex-none gap-x-8 px-2 text-lg font-semibold text-grayscale-body-light">
				<li v-for="(tab, index) in tabs" :key="tab.name">
					<span class="cursor-pointer" :class="currentTabIndex === index ? 'text-information' : 'hover:text-grayscale-body'" @click="tabSelected(index)">{{ tab.name }}</span>
				</li>
			</ul>
		</nav>
		<userpilot-exclude>
			<div class="mt-5"><PortalSettingsPage v-if="currentTabIndex === 0" :connected-users="connUsers"/></div>
			<div class="mt-5"><AppServiceErrors v-if="currentTabIndex === 1"/></div>
			<div class="mt-[-8px]"><Maintenance v-if="currentTabIndex === 2"/></div>
			<div class="mt-5"><ModuleSettings v-if="currentTabIndex === 3"/></div>
			<div class="mt-5"><EmailLogs v-if="currentTabIndex === 4"/></div>
			<div class="mt-5"><ScheduledReportSettings v-if="currentTabIndex === 5"/></div>
		</userpilot-exclude>
	</AdminLayout>
</template>